import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Loader {
  private readonly activeCount = signal(0);
  readonly isLoading = signal(false);

  show(): void {
    this.activeCount.update((count) => count + 1);
    this.isLoading.set(true);
  }

  hide(): void {
    this.activeCount.update((count) => Math.max(0, count - 1));
    this.isLoading.set(this.activeCount() > 0);
  }

  reset(): void {
    this.activeCount.set(0);
    this.isLoading.set(false);
  }
}
